import { createActions, createReducer } from "reduxsauce";

//Action types e Creators
export const { Types, Creators } = createActions({
	cdSelect: ['cd'],
	cdDetails: ["orders"],
	setCdHours: ['orders'],
	cdDetailsUpdate: ["orders"],
	cdDetailsClean: [],
	cdDetailsHoursUpdate: ["hours"],
	cdCleanDetailsHoursUpdate: [],
	cdDetailsCleanAll: [],
	cdHourError:[''],
	cdHourSuccess:['']

});

//Reducer Handlers
const INITIAL_STATE = {
	cdSelect: null,
	cdDetails: null,
	cdDetailsUpdate: null,
	cdDetailsHoursUpdate: {
		id: null,
		hrInicial: null,
		hrFim: null
	},
	cdHourError: [],
	cdHourSuccess: []
};

const cdSelect = (state = INITIAL_STATE, action) => {
	return { ...state, cdSelect: action.id }
}

const cdDetails = (state = INITIAL_STATE, action) => {
	return { ...state, cdDetails: action.payload }
};

const cdDetailsUpdate = (state = INITIAL_STATE, action) => {
	return { ...state, cdDetailsUpdate: action.payload }
};

const cleanCdDetails = (state = INITIAL_STATE, action) => {
	return { ...state, cdDetails: null }
};

const cdDetailsHoursUpdate = (state = INITIAL_STATE, action) => {
	return { ...state, selectOrdersModal: [...state.selectOrdersModal, action.orderId] }
};

const cdCleanDetailsHoursUpdate = (state = INITIAL_STATE, action) => {
	return {
		...state, cdDetailsHoursUpdate: {
			id: null,
			hrInicial: null,
			hrFim: null
		}
	}
};

const cdHourError = (state = INITIAL_STATE, action) => {
	return { 
		...state, 
		cdHourError: {
			...action.payload 
		}
	}
};

const cdHourSuccess = (state = INITIAL_STATE, action) => {
	return { 
		...state, 
		cdHourSuccess: {
			...action.payload 
		}
	}
};

const cleanAll = (state = INITIAL_STATE, action) =>
	INITIAL_STATE

//Criando Reducer
export default createReducer(INITIAL_STATE, {
	[Types.CD_SELECT]: cdSelect,
	[Types.CD_DETAILS]: cdDetails,
	[Types.CD_DETAILS_CLEAN]: cleanCdDetails,
	[Types.CD_DETAILS_HOURS_UPDATE]: cdDetailsHoursUpdate,
	[Types.CD_CLEAN_DETAILS_HOURS_UPDATE]: cdCleanDetailsHoursUpdate,
	[Types.CD_DETAILS_CLEAN_ALL]: cleanAll,
	[Types.CD_DETAILS_UPDATE]: cdDetailsUpdate,
	[Types.CD_HOUR_ERROR]: cdHourError,
	[Types.CD_HOUR_SUCCESS]: cdHourSuccess
});
